// If component is exported as default, we need to import it as default
// PDR: https://github.com/gdcorp-uxp/pdrs/blob/main/storefront-platform/webpack-esm.md#default-exports
import FixedBanner from '@site/fos-header-footer/temp/fixed-banner/index.js';
import CurrencyGrowl from '@site/fos-header-footer/header/currency-growl/index.js';
import { PrimaryNav, SalesFooter } from '@site/pattern-library-facade/hcs';
import Tag from '@ux/tag';
import { Icon } from '@site/pattern-library-utils/icon';

export const componentMap = {
  PrimaryNav,
  SalesFooter,
  FixedBanner: FixedBanner.default,
  CurrencyGrowl: CurrencyGrowl.default,
  Tag,
  Icon
};
